<template>
  <div v-if="!appStore.navbar" class="fixed-settings" @click="setVisible">
    <el-button type="primary">
      <template #icon>
        <Setting />
      </template>
    </el-button>
  </div>
  <el-drawer
    :size="300"
    destroy-on-close
    :model-value="visible"
    @close="cancel"
  >
    <template #header>{{ $t("settings.title") }}</template>
    <Block :options="contentOpts" :title="$t('settings.content')" />
    <Block :options="othersOpts" :title="$t('settings.otherSettings')" />
    <el-alert>{{ $t("settings.alertContent") }}</el-alert>
    <template #footer>
      <el-button @click="cancel">{{ $t("settings.close") }}</el-button>
      <el-button type="primary" @click="copySettings">{{ $t("settings.copySettings") }}</el-button>
    </template>
  </el-drawer>
</template>

<script>
import { Setting } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useClipboard } from "@vueuse/core";
import { useAppStore } from "@/store";
import Block from "./block.vue";

export default {
  components: { Setting, Block },
  emits: ["cancel"],
  data() {
    const { copy } = useClipboard();
    return {
      appStore: useAppStore(),
      copyToClipboard: copy
    };
  },
  computed: {
    visible() {
      return this.appStore.globalSettings;
    },
    contentOpts() {
      return [
        { name: "settings.navbar", key: "navbar", defaultVal: this.appStore.navbar },
        { name: "settings.menu", key: "menu", defaultVal: this.appStore.menu },
        { name: "settings.footer", key: "footer", defaultVal: this.appStore.footer },
        { name: "settings.tabBar", key: "tabBar", defaultVal: this.appStore.tabBar },
        { name: "settings.menuFromServer", key: "menuFromServer", defaultVal: this.appStore.menuFromServer },
        { name: "settings.menuWidth", key: "menuWidth", defaultVal: this.appStore.menuWidth, type: "number" }
      ];
    },
    othersOpts() {
      return [
        { name: "settings.colorWeak", key: "colorWeak", defaultVal: this.appStore.colorWeak }
      ];
    }
  },
  methods: {
    cancel() {
      this.appStore.updateSettings({ globalSettings: false });
      this.$emit("cancel");
    },
    async copySettings() {
      const text = JSON.stringify(this.appStore.$state, null, 2);
      await this.copyToClipboard(text);
      ElMessage.success(this.$t("settings.copySettings.message"));
    },
    setVisible() {
      this.appStore.updateSettings({ globalSettings: true });
    }
  }
};
</script>

<style scoped lang="less">
.fixed-settings {
  position: fixed;
  top: 280px;
  right: 0;

  svg {
    font-size: 18px;
    vertical-align: -4px;
  }
}
</style>
